import { render, staticRenderFns } from "./ManualFights.vue?vue&type=template&id=20289896&"
import script from "./ManualFights.vue?vue&type=script&lang=js&"
export * from "./ManualFights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports